import React, { useState, useEffect } from "react";
import "./App.css";
import MainRouter from "./components/MainRouter";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  const [showIntro, setShowIntro] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowIntro(false);
    }, 6000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <MainRouter />
    </>
  );
}

export default App;
